import moment from 'moment';

/**
 * Formats a date-only string (ISO `yyyy-mm-dd`, e.g. an exception `expirationDate`) for display.
 * Parses as a local calendar date (no timezone conversion) to avoid the off-by-one-day shift that
 * `moment.utc(...).local()` produces for date-only values in negative-offset timezones.
 */
export function formatDateOnly(value: string | null | undefined, format = 'MMM D, YYYY'): string {
    if (!value) {
        return '';
    }
    const parsed = moment(value, 'YYYY-MM-DD', true);
    return parsed.isValid() ? parsed.format(format) : '';
}
